import React from 'react';
import { CheckSquare, Square } from 'lucide-react';

// List of extracted text snippets with per-snippet selection checkboxes.
const TextSnippetsList = ({
  textSnippets,
  selectedTexts,
  allTextsSelected,
  onToggleSelectedText,
  onToggleSelectAllTexts,
}) => (
  <div className="mb-4 border border-slate-200 rounded-lg">
    <div className="p-3 border-b border-slate-200 flex items-center justify-between">
      <div className="text-sm font-semibold text-slate-700">Relevant Text Snippets ({textSnippets.length})</div>
      <button type="button" onClick={onToggleSelectAllTexts} disabled={textSnippets.length === 0} className="text-sm text-blue-600 disabled:text-slate-400 inline-flex items-center gap-1">
        {allTextsSelected ? <CheckSquare size={14} /> : <Square size={14} />}
        {allTextsSelected ? 'Deselect all' : 'Select all'}
      </button>
    </div>
    <div className="max-h-[260px] overflow-auto p-2 space-y-2">
      {textSnippets.length === 0 ? (
        <div className="text-sm text-slate-500 p-2">No text snippets extracted.</div>
      ) : textSnippets.map((row, index) => (
        <label key={`${row.text}-${index}`} className="flex items-start gap-2 p-2 hover:bg-slate-50 rounded cursor-pointer">
          <input
            type="checkbox"
            checked={selectedTexts.includes(row.text)}
            onChange={() => onToggleSelectedText(row.text)}
            className="mt-1"
          />
          <div className="min-w-0">
            <div className="text-sm text-slate-700">{row.text}</div>
            <div className={`text-[11px] ${row.selected !== false ? 'text-emerald-600' : 'text-amber-700'} truncate`}>
              {row.selection_reason || (row.selected !== false ? 'selected' : 'deselected')}
            </div>
          </div>
        </label>
      ))}
    </div>
  </div>
);

export default TextSnippetsList;
